import "../../config/sentry";

import "bootstrap/js/collapse.js";
import "bootstrap/js/dropdown.js";

import "bootstrap/dist/css/bootstrap.css";
import "../../../css/global-legacy.css";
import "../../../css/fonts.css";
import "../../../css/entry.css";
import "../../../css/header.css";
import "../../../css/footer.css";
import "../../../css/lucide.css";
import "../../../css/z-index-scale.css";
import "../../../css/ratingSnippet.css";
import "../../../css/components/uspBanner.css";
import "../../../css/components/productCard.css";
import "../../../css/components/imageFrame.css";
import "../../../css/components/carousel.css";
import "../../../css/components/dialogs.css";
import "../../../css/components/video-player.css";

import { initAttribution } from "../../services/attributionService";
import { infoMessage } from "../../theme/modules/jquery/infoMessage";
import { addUserIdTracking } from "../../analytics/gaUserTracking";
import { initLogoutHandler } from "../../analytics/logoutHandler";
import { cookieConsentWidget } from "./cookieConsentWidget";
import { mobileNavMenu } from "./mobileNavMenu";
import { initializeEmailTracking } from "../../events/ga4/highValueCustByEmail";
import { afterPrerender } from "../../utils/afterPrerender";
import { onReady } from "../../utils/onReady";
import { safeCall } from "../../utils/safeCall";
import { initAppHeight } from "../../utils/appHeight";
import { initDismissBars } from "../../theme/modules/dismissBar";
import "../../../css/components/announcementBar.css";
import "../../../css/components/trustBar.css";
import "../../../css/components/promoBanner.css";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

window.dataLayer = window.dataLayer ?? [];
afterPrerender(initAttribution, "global", "initAttribution");

function initGlobal(): void {
  safeCall(initAppHeight, "global", "initAppHeight");
  infoMessage();
  afterPrerender(addUserIdTracking, "global", "addUserIdTracking");
  initLogoutHandler();
  cookieConsentWidget();
  mobileNavMenu();
  initializeEmailTracking();
  safeCall(initDismissBars, "global", "initDismissBars");
}

onReady(() => {
  safeCall(initGlobal, "global");
});
